
import { firebaseDB, firebaseAnalytics } from "../firebase";
import { logEvent } from 'firebase/analytics';

import { doc, getDoc, updateDoc, collection, getDocs, addDoc, onSnapshot, increment } from 'firebase/firestore';

import { useUser } from './../hooks/useUser';



export const useFirebaseServices = (setPaid, setPriceAmount, setCurrency) => {



  const { user, loading } = useUser();


  const updateResultsDB = async (data) => {

    if (user == null) return false;

    const docRef = doc(firebaseDB, "users", user.uid);

    try {
      await updateDoc(docRef, {
        personalityData: data
      });
      return true;
    }
    catch (error) {
      console.log("Error updating document:" + error);
      return false;
    }

  }


  const deleteResults = async () => {

    if (user == null) return false;

    const docRef = doc(firebaseDB, "users", user.uid);

    try {
      await updateDoc(docRef, {
        personalityData: null
      });
      return true;
    }
    catch (error) {
      console.log("Error updating document:" + error);
      return false;
    }

  }

  // not used
  const addTestTaken = async () => {

    console.log("Adding");
    const docRef = doc(firebaseDB, "siteStats", "10X82e0VnFLSP5tTAAyK");

    try {
      await updateDoc(docRef, {
        testsTaken: increment(1)  // Atomically adds 1
      });
      return true;
    }
    catch (error) {
      console.log("Error updating document:" + error);
      return false;
    }
  };


  const makePremium = async () => {

    if (user == null) return false;


    const docRef = doc(firebaseDB, "users", user.uid);
    const docSnap = await getDoc(docRef);
    const docData = docSnap.data();

    const changePremium = !(docData.isPaid);
    //console.log("changePremium = " + changePremium);

    try {
      if (docRef != null) {
        await updateDoc(docRef, {
          isPaid: changePremium
        });
        setPaid(changePremium);
        return true;
      }
    }
    catch (error) {
      console.log("Error updating document:" + error);
      return false;
    }
  }


  const fetchProducts = async () => {
    try {

      const pricesCollectionRef = collection(firebaseDB, 'products', 'prod_STF4WVdGQXjAk1', 'prices');

      const snapshot = await getDocs(pricesCollectionRef);

      snapshot.forEach((doc) => {

        const priceAmount = doc.data().unit_amount;
        const currency = doc.data().currency;

        //console.log(priceAmount);

        setPriceAmount(priceAmount);
        setCurrency(currency);
        return true;

      });

    } catch (error) {
      console.error("Error fetching products:", error);
      return false;
    }
  };


  const checkout = async () => {
    try {

      // Log checkout initiation
      logEvent(firebaseAnalytics, 'begin_checkout', {
        currency: 'NZD',
        value: 12.00,
        items: [{
          item_name: 'Big Five Premium test',
        }]
      });


      // Using the updated Firestore syntax
      const docRef = await addDoc(
        collection(
          doc(collection(firebaseDB, "customers"), user.uid),
          "checkout_sessions"
        ),
        {
          mode: "payment",
          allow_promotion_codes: true,
          price: "price_1RYIaF07VSF8mzuZXfB8l55y", // One-time price created in Stripe
          success_url: `${window.location.origin}/success`,
          cancel_url: `${window.location.origin}/failure`,
        }
      );

      onSnapshot(docRef, (snap) => {
        const { error, url } = snap.data();
        if (error) {

          // Log checkout error
          logEvent(firebaseAnalytics, 'checkout_error', {
            error_message: error.message,
            price_id: 'price_1RYIaF07VSF8mzuZXfB8l55y'
          });

          // Show an error to your customer and
          // inspect your Cloud Function logs in the Firebase console.
          console.error(`An error occurred: ${error.message}`);
        }
        if (url) {

          if (url == `${window.location.origin}/success`) {

            // Log purchase success
            logEvent(firebaseAnalytics, 'purchase', {
              value: 1,
              currency: 'NZD',
              items: [{
                item_name: 'Big Five Premium test',
                price: 12.00
              }]
            });

          }
          // We have a Stripe Checkout URL, redirect.
          window.location.assign(url);
        }
      });

    } catch (error) {
      console.error("Error during checkout:", error);
    }
  };


  const checkPaidStatus = async () => {
    try {
      if (!user) {

        setPaid(false);
        return false;
      }

      const snapshot = await getDocs(collection(firebaseDB, "customers", user.uid, "payments"));

      let successfullPayment = false;

      snapshot.forEach((doc) => {

        //console.log(doc.data());

        if (doc.data().status == "succeeded") {

          successfullPayment = true;
        }

      });

      if (successfullPayment == true) {
        //console.log("paid!");
        setPaid(true);
        return true;
      }

      setPaid(false);
      return false;

    } catch (error) {
      console.error('Error checking payment status:', error);
      setPaid(false);
      return { error: error.message };
    }
  };



  return {
    makePremium, deleteResults, addTestTaken, updateResultsDB, fetchProducts, checkout, checkPaidStatus
  }

}



